<template>
    <v-col class="pa-0">
        <div class="kt-header__topbar kt-grid__item kt-grid__item--fluid" :class="$vuetify.breakpoint.smAndDown ? 'justify-center mt-3' : 'float-right mt-0'" id="kt_header_topbar">
            <!-- Search -->
            <div class="kt-header__topbar-item kt-header__topbar-item--search dropdown">
                <div class="kt-header__topbar-wrapper" data-toggle="dropdown">
                    <span class="kt-header__topbar-icon kt-header__topbar-icon--nav" ><i class="flaticon2-search-1"></i></span>
                </div>
                <div class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-lg p-4">
                    <div class="kt-quick-search kt-quick-search--dropdown kt-quick-search--result-compact" :class="{'kt-quick-search--has-result': showSearchResults}" id="vue_search_dropdown">
                        <form method="get" class="kt-quick-search__form">
                            <div class="input-group">
                                <div class="input-group-prepend"><span class="input-group-text"><i class="flaticon2-search-1"></i></span></div>
                                <input 
                                    type="text" 
                                    class="form-control-search form-control kt-quick-search__input" 
                                    placeholder="Search..." 
                                    v-model="searchQuery"
                                    @input="onSearchInput"
                                    @focus="showSearchResults = true">
                                <div class="input-group-append">
                                    <span class="input-group-text" @click="clearSearch" style="cursor: pointer;">
                                        <i class="la la-close kt-quick-search__close"></i>
                                    </span>
                                </div>
                            </div>
                        </form>
                        <div class="kt-quick-search__wrapper kt-scroll" data-scroll="true" data-height="325" data-mobile-height="200">
                            <div class="kt-quick-search__result">
                                <div v-if="searchLoading" class="kt-quick-search__message text-center">
                                    <i class="fas fa-spinner fa-spin"></i> Searching...
                                </div>
                                <div v-else-if="searchResults.length === 0" class="kt-quick-search__message">
                                    No record found
                                </div>
                                <template v-else>
                                    <div class="kt-quick-search__category">Leads</div>
                                    <div class="kt-quick-search__section">
                                        <div 
                                            v-for="(user, index) in searchResults" 
                                            :key="`search-${user.id}-${index}`" 
                                            class="kt-quick-search__item"
                                            style="cursor: pointer;">
                                            <div class="kt-quick-search__item-img kt-quick-search__item-img--file">
                                                <i class="fas fa-user"></i>
                                            </div>
                                            <div class="kt-quick-search__item-wrapper">
                                                <router-link :to="{ name: 'profile', query: {id: user.id} }">
                                                    <span class="kt-quick-search__item-title">
                                                        {{ user.first_name }} {{ user.last_name }}
                                                    </span>
                                                    <div class="kt-quick-search__item-desc">
                                                        {{ user.phone }} - {{ user.email }}
                                                    </div>
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Notifications -->
            <div class="kt-header__topbar-item dropdown">
                <div class="kt-header__topbar-wrapper" data-toggle="dropdown">
                    <span class="kt-header__topbar-icon kt-header__topbar-icon--nav">
                    <i class="flaticon2-bell-alarm-symbol"></i>
                    </span>
                    <span v-if="notificationCount > 0" class="kt-badge kt-badge--danger" :style="`width: calc((${notificationCount.toString().length} * 2px) + 16px) !important;`">{{ notificationCount }}</span>
                </div>
                <div class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-xl p-4">
                    <NotificationsDropdownMenu />
                </div>
            </div>

            <!-- Support -->
            <div v-if="currentUserCanUse(FeatureFlags.KEY_SUPPORT)" class="kt-header__topbar-item kt-header__topbar-item--langs dropdown">
                <div class="kt-header__topbar-wrapper" data-toggle="dropdown">
                    <span class="kt-header__topbar-icon kt-header__topbar-icon--nav">
                        <i class="flaticon2-help"></i>
                    </span>
                    <span v-if="supportCount > 0" class="kt-badge kt-badge--danger" :style="`width: calc((${supportCount.toString().length} * 2px) + 16px) !important;`">{{ supportCount }}</span>
                </div>
                <div class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim p-4">
                    <ul class="kt-nav">
                        <li class="kt-nav__item">
                            <router-link :to="{ name: 'support'}" class="kt-nav__link">
                                <span class="kt-nav__link-icon"><i class="flaticon2-help"></i></span>
                                <span class="kt-nav__link-text">
                                Support <span v-if="supportCount > 0" class="kt-badge kt-badge--danger" :style="`width: calc((${supportCount.toString().length} * 2px) + 16px) !important;`" style="margin-left:8px;">{{ supportCount }}</span>
                                </span>
                            </router-link>
                        </li>
                        <li v-if="currentUser && currentUser.client && currentUser.client.platform == 'nxlead'" class="kt-nav__item pt-4">
                            <router-link :to="{ name: 'learning-center'}" class="kt-nav__link">
                                <span class="kt-nav__link-icon"><i class="fas fa-graduation-cap"></i></span>
                                <span class="kt-nav__link-text">University</span>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Tasks -->
            <div v-if="currentUserCanUse(FeatureFlags.KEY_TASKS)" class="kt-header__topbar-item dropdown">
                <div class="kt-header__topbar-wrapper" data-toggle="dropdown">
                    <span class="kt-header__topbar-icon kt-header__topbar-icon--nav"><i class="flaticon2-list-1"></i></span>
                    <span v-if="allTasksCount > 0" class="kt-badge kt-badge--danger" :style="`width: calc((${allTasksCount.toString().length} * 2px) + 16px) !important;`">{{ allTasksCount }}</span>
                </div>
                <div class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-xl p-4">
                    <form>
                        <div class="kt-head kt-head--skin-light">
                            <div class="kt-head__title">
                                <h3>Tasks</h3>
                                <span class="kt-space-15"></span>
                                <router-link :to="{ name: 'tasks', query: {status: 'P'}}" class="btn btn-primary btn-sm btn-bold btn-font-md" style="color: white !important; background-color: var(--primary-color) !important; border: none !important;">{{ allTasksCount }} task{{ allTasksCount == 1 ? '' : 's' }} pending</router-link>
                            </div>
                        </div>
                        <div class="kt-grid-nav kt-grid-nav--skin-light">
                            <div class="kt-grid-nav__row">
                                <router-link :to="{ name: 'tasks', query: {date_type: 'date', start: formatDate(new Date()), end: formatDate(new Date(new Date().getTime() + 86400000))}}" class="kt-grid-nav__item">
                                    <span class="kt-grid-nav__icon">
                                    <i class="flaticon2-list-1 kt-font-success"></i>
                                    </span>
                                    <span class="kt-grid-nav__title">Today</span>
                                    <span class="kt-grid-nav__desc">{{todayTasksCount}} Task{{ todayTasksCount == 1 ? '' : 's' }} Due Today</span>
                                </router-link>
                                <router-link :to="{ name: 'tasks', query: {date_type: 'date', end: formatDate(new Date(new Date().getTime() + 86400000)), status: 'P'}}" class="kt-grid-nav__item">
                                    <span class="kt-grid-nav__icon">
                                    <i class="flaticon2-list-1 kt-font-danger"></i>
                                    </span>
                                    <span class="kt-grid-nav__title">Overdue</span>
                                    <span class="kt-grid-nav__desc">{{overdueTasksCount}}  Overdue Task{{ overdueTasksCount == 1 ? '' : 's' }}</span>
                                </router-link>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <!-- User bar -->
            <div class="kt-header__topbar-item kt-header__topbar-item--user dropdown">
                <div class="kt-header__topbar-wrapper" data-toggle="dropdown">
                    <span class="kt-hidden kt-header__topbar-welcome">Hi,</span>
                    <span class="kt-hidden kt-header__topbar-username">{{currentUser && currentUser.firstname}}</span>
                    <img v-if="currentUser && currentUser.id" alt="Pic" :src="apiBaseUrl + '/agentProfileImg?id=' + currentUser.id + (profileImageVersion ? '&v=' + profileImageVersion : '')"/>
                </div>
                <div class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-xl p-4">
                    <!--begin: Head -->
                    <div class="kt-user-card kt-user-card--skin-light kt-notification-item-padding-x">
                        <div class="kt-user-card__avatar">
                            <img v-if="currentUser && currentUser.id" alt="Pic" :src="apiBaseUrl + '/agentProfileImg?id=' + currentUser.id + (profileImageVersion ? '&v=' + profileImageVersion : '')"/>
                        </div>
                        <div class="kt-user-card__name">{{ currentUser && currentUser.full_name }}</div>
                    </div>
                    <!--end: Head -->

                    <!--begin: Navigation -->
                    <div class="kt-notification">
                        <router-link :to="{name: (platform == 'ppc' ? 'user-profile' : 'user-profile-nxlead')}" class="kt-notification__item">
                            <div class="kt-notification__item-icon">
                            <i class="flaticon2-calendar-3 kt-font-primary"></i>
                            </div>
                            <div class="kt-notification__item-details">
                            <div class="kt-notification__item-title kt-font-bold">
                                <span>My Profile</span>
                                <i class="mdi mdi-chevron-right kt-notification__item-icon"></i>
                            </div>
                            </div>
                        </router-link>

                        <router-link v-if="platform == 'ppc' && currentUserCanUse(FeatureFlags.KEY_HJ_PLUS)" :to="{name: 'housejet-plus'}" class="kt-notification__item">
                            <div class="kt-notification__item-icon">
                            <img src="/images/logos/housejet/hj-plus-tiny-icon.png" width="19" />
                            </div>
                            <div class="kt-notification__item-details">
                            <div class="kt-notification__item-title kt-font-bold">
                                <span>HOUSEJET+</span>
                                <i class="mdi mdi-chevron-right kt-notification__item-icon"></i>
                            </div>
                            </div>
                        </router-link>

                        <router-link v-if="platform == 'ppc' && currentUserCanUse(FeatureFlags.KEY_COMMISSION_SHARE_PROGRAM)" :to="{name: 'commission-share'}" class="kt-notification__item">
                            <div class="kt-notification__item-icon">
                                <i class="flaticon2-line-chart kt-font-primary"></i>
                            </div>
                            <div class="kt-notification__item-details">
                                <div class="kt-notification__item-title kt-font-bold">
                                <span>Commission Share Program</span>
                                <i class="mdi mdi-chevron-right kt-notification__item-icon"></i>
                                </div>
                            </div>
                        </router-link>
                        <router-link v-if="currentUserCanUse(FeatureFlags.KEY_SERVICE_AREAS)" :to="{name: 'service-areas'}" class="kt-notification__item">
                            <div class="kt-notification__item-icon">
                                <i class="flaticon2-location kt-font-primary"></i>
                            </div>
                            <div class="kt-notification__item-details">
                                <div class="kt-notification__item-title kt-font-bold">
                                <span>Service Areas</span>
                                <i class="mdi mdi-chevron-right kt-notification__item-icon"></i>
                                </div>
                            </div>
                        </router-link>

                        <router-link v-if="platform == 'ppc' && currentUserCanUse(FeatureFlags.KEY_WEBSITES)" :to="{name: 'housejet-website-setup'}" class="kt-notification__item">
                            <div class="kt-notification__item-icon">
                                <i class="flaticon2-website kt-font-primary"></i>
                            </div>
                            <div class="kt-notification__item-details">
                                <div class="kt-notification__item-title kt-font-bold">
                                <span>Website</span>
                                <i class="mdi mdi-chevron-right kt-notification__item-icon"></i>
                                </div>
                            </div>
                        </router-link>

                        <router-link v-if="platform == 'nxlead'" :to="{name: 'mailbox'}" class="kt-notification__item">
                            <div class="kt-notification__item-icon">
                                <i class="flaticon2-mail kt-font-primary"></i>
                            </div>
                            <div class="kt-notification__item-details">
                                <div class="kt-notification__item-title kt-font-bold">
                                    <span>My Messages</span>
                                    <i class="mdi mdi-chevron-right kt-notification__item-icon"></i>
                                </div>
                            </div>
                        </router-link>

                        <router-link v-if="currentUserCanUse(FeatureFlags.KEY_CONNECTED_ACCOUNTS)" :to="{name: 'connected-accounts'}" class="kt-notification__item">
                            <div class="kt-notification__item-icon">
                                <i class="flaticon2-start-up kt-font-primary"></i>
                            </div>
                            <div class="kt-notification__item-details">
                                <div class="kt-notification__item-title kt-font-bold">
                                    <span>Connected Accounts</span>
                                    <i class="mdi mdi-chevron-right kt-notification__item-icon"></i>
                                </div>
                            </div>
                        </router-link>

                        <router-link v-if="currentUserCanUse(FeatureFlags.KEY_MY_FILES)" :to="{name: 'agent-files'}" class="kt-notification__item">
                            <div class="kt-notification__item-icon">
                                <i class="flaticon2-file-2 kt-font-primary"></i>
                            </div>
                            <div class="kt-notification__item-details">
                                <div class="kt-notification__item-title kt-font-bold">
                                    <span>My Files</span>
                                    <i class="mdi mdi-chevron-right kt-notification__item-icon"></i>
                                </div>
                            </div>
                        </router-link>

                        <router-link v-if="platform == 'nxlead' && currentUser.role == 'admin'" :to="{name: 'settings-admin'}" class="kt-notification__item">
                            <div class="kt-notification__item-icon">
                                <i class="flaticon2-hourglass kt-font-primary"></i>
                            </div>
                            <div class="kt-notification__item-details">
                                <div class="kt-notification__item-title kt-font-bold">
                                    <span>Settings</span>
                                    <i class="mdi mdi-chevron-right kt-notification__item-icon"></i>
                                </div>
                            </div>
                        </router-link>

                        <router-link v-if="currentUserCanUse(FeatureFlags.KEY_BILLING)" :to="{name: (platform == 'ppc' ? 'ppc-billing' : 'housejet-billing-profile')}" class="kt-notification__item">
                            <div class="kt-notification__item-icon">
                                <i class="flaticon2-cardiogram kt-font-primary"></i>
                            </div>
                            <div class="kt-notification__item-details">
                                <div class="kt-notification__item-title kt-font-bold">
                                    <span>Billing</span>
                                    <i class="mdi mdi-chevron-right kt-notification__item-icon"></i>
                                </div>
                            </div>
                        </router-link>

                      <router-link v-if="currentUserCanUse(FeatureFlags.KEY_USAGE)" :to="{name: 'usage'}" class="kt-notification__item">
                        <div class="kt-notification__item-icon">
                          <i class="flaticon2-pie-chart-2 kt-font-primary"></i>
                        </div>
                        <div class="kt-notification__item-details">
                          <div class="kt-notification__item-title kt-font-bold">
                            <span>Usage</span>
                            <i class="mdi mdi-chevron-right kt-notification__item-icon"></i>
                          </div>
                        </div>
                      </router-link>

                        <router-link v-if="currentUserCanUse(FeatureFlags.KEY_UPGRADE)" :to="{name: 'upgrade'}" class="kt-notification__item">
                            <div class="kt-notification__item-icon">
                                <i class="flaticon2-arrow-up kt-font-primary"></i>
                            </div>
                            <div class="kt-notification__item-details">
                                <div class="kt-notification__item-title kt-font-bold">
                                <span>Upgrade / Downgrade</span>
                                  <i class="mdi mdi-chevron-right kt-notification__item-icon"></i>
                                </div>
                            </div>
                        </router-link>

                        <div class="kt-notification__custom kt-space-between">
                            <router-link :to="{name: 'prelogout'}" class="btn btn-label btn-sm btn-bold button-primary" style="color: var(--tertiary);">Sign Out</router-link>
                        </div>


                    </div>
                    <!--end: Navigation -->
                </div>
            </div>
            <!--end: User bar -->
        </div>
    </v-col>
</template>

<script>
import { FeatureFlags } from '@/options/featureFlags.js'
import NotificationsDropdownMenu from '../Notifications/NotificationsDropdownMenu.vue';
import getCurrentUserX from '@/mixins/getCurrentUserX'

export default {
    name: "badgeNavigation",
    components: { NotificationsDropdownMenu },
    mixins: [getCurrentUserX],
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
    },

    data(){
        return {
            notificationCount: 0,
            supportCount: 0,
            allTasksCount: 0,
            todayTasksCount: 0,
            overdueTasksCount: 0,
            admins: {},
            showSearchResults: false,
            searchQuery: '',
            searchResults: [],
            searchLoading: false,
            searchTimeout: null,
        }
    },
    async mounted() {
        await this.getBadgeCounts();
        this.$root.$on('refreshBadgeCounts', this.getBadgeCounts);
    },
    beforeDestroy() {
        this.$root.$off('refreshBadgeCounts', this.getBadgeCounts);
    },
    computed: {
        FeatureFlags(){ return FeatureFlags },
        platform() {
            return this.currentUser?.client?.platform || 'ppc';
        },
    },
    methods: {
        async getBadgeCounts(){
            this.notificationCount = await this.$http.get(`/api/v1/notificationMessages/getCount`).then(response => response.data.notificationCount);
            this.supportCount = await this.$http.get(`/api/v1/supportTickets/getSupportTicketsCount`).then(response => response.data.count); 
            this.allTasksCount = await this.$http.get(`/api/v1/userTasks/getTasksCount`).then(response => response.data.count); 
            this.todayTasksCount = await this.$http.get(`/api/v1/userTasks/getTasksToday`).then(response => response.data.count); 
            this.overdueTasksCount = await this.$http.get(`/api/v1/userTasks/getTasksOverdue`).then(response => response.data.count); 
            this.appointmentsCount = await this.$http.get(`/api/v1/userTasks/getAppointmentsCount`).then(response => response.data.count); 
            this.remindersCount = await this.$http.get(`/api/v1/userTasks/getRemindersCount`).then(response => response.data.count);
        },
        formatDate(date) {
            return date.toLocaleString('en-US', {
                month: '2-digit', day: '2-digit', year: 'numeric',
                hour: 'numeric', minute: '2-digit', hour12: true
            }).replace(',', '');
        },
        async performSearch(query) {
            if (!query || query.length < 2) {
                this.searchResults = [];
                this.showSearchResults = false;
                return;
            }

            this.searchLoading = true;
            
            try {
                console.log('Searching for:', query); // Debug log
                const response = await this.$http.get('/agents/ajax/GetUserNames', {
                    params: {
                        term: query,
                        extraData: true
                    }
                });
                
                console.log('Search response:', response.data); // Debug log
                console.log('Setting search results, length:', response.data.length); // Debug log
                this.searchResults = response.data;
                this.showSearchResults = true;
                console.log('showSearchResults:', this.showSearchResults, 'searchQuery:', this.searchQuery); // Debug log
            } catch (error) {
                console.error('Search error:', error);
                this.searchResults = [];
            } finally {
                this.searchLoading = false;
            }
        },
        onSearchInput(event) {
            const query = event.target.value;
            this.searchQuery = query;
            
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }
            
            this.searchTimeout = setTimeout(() => {
                this.performSearch(query);
            }, 300);
        },
        clearSearch() {
            this.searchQuery = '';
            this.searchResults = [];
            this.showSearchResults = false;
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }
        },
    }
}
</script>

<style scoped>
.kt-quick-search.kt-quick-search--has-result .kt-quick-search__wrapper {
    overflow-y: auto !important;
}
</style>